import React, {
  useContext,
  useState,
} from "react";
import Card from "../UI/Card";
import styles from "./Home.module.css";
import { AuthContext } from "../../store/auth-context";
import Button from "../UI/Button";
const Home = () => {
  const [showProfile, setShowProfile] =
    useState(false);
  const toggleProfileHandler = () => {
    setShowProfile((prevState) => {
      return !prevState;
    });
  };
  const homeCtx = useContext(AuthContext);
  const userData = homeCtx.userData;

  return (
    <Card className={styles["home-card"]}>
      <h2>Welcome back!</h2>
      <Button onClick={toggleProfileHandler}>
        {showProfile
          ? "Hide my profile"
          : "Show my profile"}
      </Button>
      {showProfile && (
        <div className={styles.profile}>
          <h3>
            Last Name:<p>{userData.lastName}</p>
          </h3>
          <h3>
            First Name:
            <p>{userData.firstName}</p>
          </h3>
          <h3>
            Email Address:
            <p>{userData.emailAddress}</p>
          </h3>
        </div>
      )}
    </Card>
  );
};

export default Home;
